import api from "../../../../../api/axios"
// import { Network } from "../../../../../legacyComponents/util"
import { Provider } from "../../../../../legacyComponents/util/api/apis/customer"

export default async function getProvider(provider) {
	try {
		const { id, externalId, name } = provider

		if (!id && name) {
			const payload = { externalId, name }
			const { data: providerData } = await api.post(`provider`,payload)
			return new Provider(providerData)
			// return await Network.API.Customer.Provider.createOne({ payload })
		} else {
			return new Provider({ ...provider })
		}
	} catch (error) {
		console.error(error)
		return {}
	}
}
